import * as React from 'react';
import { useEffect, useState } from 'react';

import { SycamoreTicketingWidgetProps } from './SycamoreTicketingWidget.props';
import { StyledTicketingWidget } from './SycamoreTicketingWidget.styles';

const getCountryCode = (locale: string | undefined) => {
  switch (locale?.toLowerCase()) {
    case 'en-us':
      return 'us';
    case 'de-de':
      return 'de';
    case 'de-at':
      return 'de';
    case 'en-gb':
      return 'uk';
    case 'es-es':
      return 'es';
    case 'es-ar':
      return 'ar';
    case 'es-bo':
      return 'bo';
    case 'es-cl':
      return 'cl';
    case 'es-co':
      return 'co';
    case 'es-cr':
      return 'cr';
    case 'es-sv':
      return 'sv';
    case 'es-gt':
      return 'gt';
    case 'es-hn':
      return 'hn';
    case 'es-mx':
      return 'mx';
    case 'es-ni':
      return 'ni';
    case 'es-pa':
      return 'pa';
    case 'es-py':
      return 'py';
    case 'es-pe':
      return 'pe';
    case 'es-uy':
      return 'uy';
    case 'es-ec':
      return 'ec';
    case 'en-ca':
      return 'ca-en';
    case 'fr-ca':
      return 'ca-fr';
    case 'nl-nl':
      return 'nl';
    case 'pl-pl':
      return 'pl';
    case 'nl-be':
      return 'be-nl';
    case 'fr-be':
      return 'be-fr';
    case 'en-in':
      return 'in';
    case 'pt-br':
      return 'br';
    default:
      return 'us';
  }
};

export const SycamoreTicketingWidget = ({ ...props }: SycamoreTicketingWidgetProps) => {
  const [hasLoadedScript, setHasLoadedScript] = useState(false);

  useEffect(() => {
    if (!hasLoadedScript) {
      let assetServerPath = 'https://d1t0cvd33zox42.cloudfront.net/';
      if (!(typeof window === 'undefined')) {
        if (window.location.href.indexOf('localhost') !== -1) {
          assetServerPath = 'http://wbportal/';
        }
      }
      const script = document.createElement('script');
      script.src = assetServerPath + 'embed/assets/js/jquery-3.6.0.min.js';
      script.async = true;
      let scriptSyca: HTMLScriptElement;
      script.onload = () => {
        scriptSyca = document.createElement('script');
        scriptSyca.src = assetServerPath + 'embed/assets/js/sycaconst.js';
        scriptSyca.async = true;
        scriptSyca.onload = () => {
          setHasLoadedScript(true);
        };
        document.body.appendChild(scriptSyca);
      };
      document.body.appendChild(script);
      return () => {
        document.body.removeChild(script);
        document.body.removeChild(scriptSyca);
      };
    }
  }, [hasLoadedScript]);

  return (
    <StyledTicketingWidget>
      <div
        id='syca_embedWBPortalContainer'
        data-countrycode={getCountryCode(props.movie.locale)}
        data-sycamovieid={props.movie.sycamoreId}
      />
    </StyledTicketingWidget>
  );
};
